import { h, Fragment, ComponentChildren } from "preact"; /** @jsx h */

import { useEffect, useState } from 'preact/hooks';
import { useAuth } from "../app/AuthProvider";
import { ROUTES } from '@pyqml/shared';

export type ISubscribeProps = {
    referenceId?: string;
    referenceType?: string;
};

export const Subscribe = (props: ISubscribeProps) => {

    const [email, setEmail] = useState("");
	const [loading, setLoading] = useState<string | undefined>(undefined);

    const { authPromise } = useAuth();
    
    return (
        <div className="border p-5 bg-lightblue">
            <div className="row justify-content-between">
                <div className="col-md-5 mb-2 mb-md-0">
                    <h5 className="font-weight-bold secondfont">Free Email Course</h5>
                    Receive a free article from the course <a href="/module/probabilistic-programming">Quantum Computing as Probabilistic Programming</a> every day by email!
                </div>
                <div className="col-md-7">
                    <div className="row">
                        <div className="col-md-12">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter your e-mail address"
                                value={email}
								onInput={e => setEmail(e.target.value)}
                            ></input>
                        </div>
                        <div className="col-md-12 mt-2">
                            { loading ? loading : <button
                                type="submit"
                                className="btn btn-success btn-block"
                                disabled={
									!(/^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/.test(email)) || loading
								}
                                onClick={()=> {
									setLoading("Please wait");
									authPromise?.({
                                        method: "post",
                                        endpoint: ROUTES.CLOUDAPI_PUBLIC_SUBSCRIBE_FREE_COURSE,
                                        queryData: {
                                            email: email,
                                            referenceId: props.referenceId,
                                            referenceType: props.referenceType
                                        }
                                    }).then(response => {
                                        console.log("response", response);

                                        if (response?.status === 200) {
                                            setLoading(response.data.message);
                                        } else {
                                            setLoading("Sorry, something went wrong. Please try again later.");
                                        }

                                          
                                    }).catch(err => {
                                        console.log("error", err);
                                        setLoading("Sorry, something went wrong. Please try again later.");
                                    });
                                    
								}}
                                >Subscribe</button> 
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>


    );
}
  
